<template>
  <b-modal  scrollable size="lg" v-model="show" centered :title="'Erlöskonto wählen'">
    <b-row>
      <b-col md="4">
        <b-form-input type="search" v-model="search" placeholder="Suchen" debounce="200" style="margin-bottom: 6px"></b-form-input>
      </b-col>
      <b-col><b-button variant="primary" class="" @click="$emit('add-k-konto'); show = false">Neues Erlöskonto anlegen</b-button></b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table id="my-table" :items="remainingKKonten"
                 striped hover selectable
                 :fields="fields"
                 :sort-by="sortBy"
                 :sort-desc="sortDesc"
                 select-mode="single"
                 selectedVariant="primary"
                 @row-selected="rowSelected">
          <template #table-colgroup="scope">
            <col
                v-for="field in scope.fields"
                :key="field.key"
                style="min-width: 100px"
            >
          </template>
        </b-table>
      </b-col>
    </b-row>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="onCancel">
        Abbrechen
      </b-button>
      <b-button size="md" variant="success" :disabled="!canContinue" @click="onSave">
        Speichern
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "SelectKKontoDialog",
  props:{
    k_konten: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      search: '',
      sortBy: 'konto',
      sortDesc: false,
      show: false,
      newAddress: {},
      selected: [],
      fields: [
        {key: "konto", label: 'Konto', sortable: true},
        {key: "konto_txt", label: 'Name', sortable: true},
        {key: "konto_grp", label: 'Gruppe', sortable: true},
        {key: "konto_typ", label: 'Typ', sortable: true},
      ],

    }
  },
  computed: {
    canContinue() {
      return this.selected.length > 0;
    },
    remainingKKonten: function () {
      let res = [];
      const filterText = this.search.trim().toLowerCase();
      if (filterText === "") {
        return this.k_konten;
      }
      for (let i = 0; i < this.k_konten.length; i++) {
        if (
            this.k_konten[i].konto.toLowerCase().indexOf(filterText) > -1
            || this.k_konten[i].konto_txt.toLowerCase().indexOf(filterText) > -1
            || this.k_konten[i].konto_grp.toLowerCase().indexOf(filterText) > -1
        ) {
          res.push(this.k_konten[i]);
        }
      }
      return res;
    }
  },
  methods: {
    rowSelected(items) {
      if (items.length === 0) {
        this.selected = [];
      } else {
        this.selected = items;
      }
    },
    onSave() {
      this.show = false;
      this.$emit("set-k-konto", this.getReturnData());
    },
    onCancel() {
      this.show = false;
    },
    showDialog() {
      this.selected = [];
      this.search = '';
      this.show = true;
    },
    getReturnData: function () {
      return this.selected[0];
    },
  }
}
</script>

<style scoped>
</style>
